import { render, staticRenderFns } from "./CustomCreateDialog.vue?vue&type=template&id=08a47602&scoped=true"
import script from "./CustomCreateDialog.vue?vue&type=script&lang=js"
export * from "./CustomCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomCreateDialog.vue?vue&type=style&index=0&id=08a47602&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a47602",
  null
  
)

export default component.exports